import { ListBox } from "primereact/listbox";
import { ProgressSpinner } from "primereact/progressspinner";
import { useQueryGtfsResource } from "../../Queries";
import gtfsFormatDate, { gtfsParseYYYYMMDD } from "../../helpers/gtfsDateUtils";
import { ToolsContext, ToolsDispatchContext } from "../../ToolsContext";
import { useContext, useState } from "react";
import { Button } from "primereact/button";
import { NewCalendarDialog } from "./NewCalendarDialog";
import React from "react";


export function CalendarPicker() {
    const {isPending, error, data} = useQueryGtfsResource('calendars');
    const tool = useContext(ToolsContext);
    const dispatch = useContext(ToolsDispatchContext);

    if (isPending || !data || !(Array.isArray(data))) return <ProgressSpinner/>;
    if (error) return error.message;

    const calendarTemplate = (option) => {
        const today = new Date();
        const dateStyle = (gtfsParseYYYYMMDD(option.start_date) < today && gtfsParseYYYYMMDD(option.end_date) > today) 
            ? 
        {fontWeight: 'bold', color: 'var(--green-700)'}
            :
        {fontWeight: 'normal'};

        return (
            <div className="flex align-items-center">
                <div style={{fontWeight: 'bold', width: '15%'}}>
                    {option.service_id}
                </div>
                <div className="text-sm" style={{width: '75%'}}>
                    {option.service_description} <br />
                    <span className="text-xs text-200">Ważny od <span style={dateStyle}>{gtfsFormatDate(option.start_date)}</span> do <span style={dateStyle}>{gtfsFormatDate(option.end_date)}</span></span>
                </div>
            </div>
        )
    }

    return (
        <>
            <ListBox 
                listStyle={{maxHeight: '90%'}}
                pt={{ header: {style: {maxHeight: '10%'}}  }}
                style={{height: '90%'}}
                options={data} 
                optionLabel="service_description"
                filter={true}
                filterBy="service_id"
                itemTemplate={calendarTemplate}
                value={tool.selection}
                onChange={(e) => dispatch({
                    type: 'changed',
                    newTool: {
                        ...tool,
                        selection: e.value,
                        propertyEditor: e.value
                    }
                })}
            >
            </ListBox>
            <CalendarBottomPanel>
                
            </CalendarBottomPanel>
        </>
    )
}
function CalendarBottomPanel() {
    const [dialogVisible,setDialogVisible] = useState(false);

    return (
        <div className="w-full p-3" style={{height: '10%'}}>
            <Button severity="success" icon="fa-solid fa-plus" label="Dodaj nowy kalendarz" outlined onClick={() => {setDialogVisible(true)}}></Button>
            <NewCalendarDialog 
                visible={dialogVisible}
                onHide={() => {if (!dialogVisible) return; setDialogVisible(false); }}      
            />
        </div>
    )
}
